module.exports = __webpack_public_path__ + "static/img/fullscreen-image_customize-your-theme-and-questions.31ad5f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surveys/fullscreen-image_customize-your-theme-and-questions.png
// module id = 0vee
// module chunks = 0